import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit'
import useTranslate from '../../../i18n/useTranslate'
import { Paper } from '@material-ui/core'
import { ButtonView } from '../../../control/button/button'

interface Props {
    id: number
    nameTH: string
    nameEN: string
    rec: string
}

const Item: React.FC<Props> = ({ id, nameTH, nameEN, rec }) => {
    const classes = useStyles()
    const history = useHistory()
    const translate = useTranslate()

    const onEdit = () => {
        history.push(`/setting-faculty/${id}/edit`)
    }

    return (
        <Paper variant="outlined" className={classes.item}>
            <Grid container spacing={2} alignItems="center">
                <Grid container item xs={12} sm={12} md={2} lg={2} alignItems="center">
                    <ButtonView className={classes.btnEdit} onClick={onEdit}>
                        {translate.get('BUTTON.EDIT')}
                    </ButtonView>
                </Grid>

                <Grid container item xs={12} sm={12} md={4} lg={4} alignItems="center">
                    <Grid item xs={12}>
                        <Typography className={classes.header} noWrap>
                            {translate.get('UM.SETTING_FACULTY.NAME_TH')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameTH}</Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={4} lg={4}>
                    <Grid item xs={12}>
                        <Typography className={classes.header} noWrap>
                            {translate.get('UM.SETTING_FACULTY.NAME_EN')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{nameEN}</Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} sm={12} md={2} lg={2}>
                    <Grid item xs={12}>
                        <Typography className={classes.header} noWrap>
                            {translate.get('UM.SETTING_FACULTY.REC')}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className={classes.multiLineEllipsis}>{rec}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    )
}

const useStyles = makeStyles((theme) => ({
    item: {
        // display: 'flex',
        // alignItems: 'center',
        padding: theme.spacing(3),
        margin: theme.spacing(2, 0),
        border: '1px solid #bdbdbd',
        // borderRadius: 4,
        // transition: '0.3s',
        // position: 'relative',
        '&:hover': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    icon: {
        marginRight: theme.spacing(1),
        width: 40,
        height: 40,
        backgroundColor: '#ece9e9',
        transition: '0.3s',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
        },
    },
    recentTime: {
        position: 'absolute',
        top: 2,
        right: 4,
        color: 'grey',
    },
    header: {
        // marginLeft: theme.spacing(1),
        fontWeight: 'bold',
    },
    btnEdit: {
        boxShadow: `0px 4px 4px ${theme.palette.grey['50']}`,
        height: '44px',
        marginRight: '1px',
    },
    multiLineEllipsis: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
}))

export default Item
